import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';

export const responseSchema = z.object({
	facilities: z
		.array(
			z.object({
				facilityName: z.string(),
				region: z.string().optional(),
				cityId: z.number().optional(),
				facilityTypeId: z.number().optional(),
				networkGroupCodes: z.array(z.string()).min(1).optional(),
				planCodes: z.array(z.string()).min(1).optional(),
				address: z.string().nullish(),
				area: z.string().nullish(),
				contactNumber: z.string().nullish(),
			})
		)
		.min(1),
});

const getExportNetworkList = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/admin/network/export',
		method: 'GET',
		responseSchema,
		requestParameters: { planCodes: ['optional', 'stringArray'], networkGroupCodes: ['optional', 'stringArray'] },
	});

export type GetExportNetworkListResponse = TypeOfAPIResponse<ReturnType<typeof getExportNetworkList>>;

export type GetExportNetworkListError = TypeOfAPIError<ReturnType<typeof getExportNetworkList>>;

export default getExportNetworkList;
